import { PipelineTemplates } from 'components/pipelineTemplates/pipelineTemplates';
import { apiUrls } from 'constants/apiurls';
import React, { useEffect } from 'react';
import pipeline from 'redux/modules/pipeline';

export const PipelineTemplateContainer = () => {
  const {
    data: pipelinesData,
    isLoading: pipelinesDataLoading,
    error: pipelinesDataError,
    isSuccess: pipelinesDataSuccess,
  } = pipeline.list().usePipelinelistQuery(
    { params: '', extendedPath: apiUrls.getPipelines() },
    {
      // skip: activeTabIndex !== 1,
    },
  );
  const [createPipeline] = pipeline.form().usePipelinecreateMutation();

  useEffect(() => {
    if (pipelinesDataSuccess && (!pipelinesData?.data || pipelinesData.data.length === 0)) {
      createPipeline({
        body: {
          title: 'Default',
          pipeline_stages: [
            { title: 'All candidates' },
            { title: 'Short list' },
            { title: 'First interview' },
            { title: 'Second interview' },
            { title: 'References' },
            { title: 'Offer made' },
            { title: 'Offer accepted' },
            { title: 'Hired' },
          ],
        },
      });
    }
  }, [pipelinesDataSuccess, pipelinesData]);
  return (
    <>
      <PipelineTemplates pipelines={pipelinesData?.data} />
    </>
  );
};
